import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import _cloneDeep from 'lodash/cloneDeep'
import { PointGroupType } from '@/models/Simulation/Constants'

export const initialState = {
  currentStep: 1,
  steps: [
    { name: 'Basic', title: '基本設定' },
    { name: 'Delivery', title: '配信対象設定' },
    { name: 'Advanced', title: '高度な設定' },
  ],
  mode: '',
  mapCenter: {
    longitude: 139.7009177,
    latitude: 35.6580971,
  },
  mapZoom: 6,
  fitBounds: false,
  selectedGroup: {
    id: null,
    type: null,
  },
  selectedLocation: {
    id: null,
  },
  lastDragEndTime: null,
  lastSettingAreaHeight: null,
  search: {
    isSearching: false,
    results: [],
    forcedResultIndex: null,
  },
  pointGroupImport: {
    selectedPointGroupType: PointGroupType.OEM,
    selectedAdvertiserId: null,
    selectedOwnerProfileId: null,
    advertiserList: [],
    IOList: [],
    pointGroupList: [],
    selectedPointGroup: null,
    selectedPointGroupList: [],
    selectedPointGroupLocationList: [],
    selectedLocationsMap: new Map(),
    mapCenter: {
      longitude: 139.7009177,
      latitude: 35.6580971,
    },
  },
}

const state = _cloneDeep(initialState)

const simulation = {
  state,
  namespaced: true,
  getters,
  actions,
  mutations,
}

export default simulation
